const React = require('react');
const connect = require('react-redux/dist/react-redux.min.js').connect;
const moment = require('moment');
const Link = require('react-router-dom').Link;
const SharedConstants = require('../../../../shared/sharedConstants');
const AjaxFunctions = require('../ajaxFunctions');
import { makeStyles, useTheme } from '@material-ui/core/styles';
import {
   Grid,
   List,
   ListSubheader,
   ListItem,
   ListItemIcon,
   ListItemText ,
} from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import AskMeAnythingCard from './askMeAnythingCard.js';
import AnnouncementsCard from './announcementsCard.js';
import MPubSearchList from './mPubSearchList.js';

const useStyles = makeStyles((theme) => ({
   incubatorListItem: {
      backgroundColor: '#F5F5F5',
      marginBottom:'10px'
   },
   incubatorListTitle: {
      fontSize: '15px',
      fontWeight: '600',
      color: '#4457CF'
   },
}));

function IncubatorListBase(props) {
   const classes = useStyles();
   const colors = ['#2C266E','#06C6D8','#89D029','#FF8A34','#0194CD','#4457CF'];
   const IncubatorSkeletons = colors.map((c, i) => <Skeleton key={i} className={classes.incubatorListItem} variant='rect' height={48}/>);
   return (
      <div>
         <List>
            <ListSubheader
               className={classes.incubatorListTitle}
               disableSticky
            >
               Active Workshops
            </ListSubheader>
            {!props.isLoaded && props.incubators.length == 0 ? (
               IncubatorSkeletons
            ) : (
               <>
                  {props.incubators.slice(0,6).map((incubator,i) =>
                     <ListItem key={incubator.id} className={classes.incubatorListItem} button component={Link} to={`/incubator?idIncubator=${incubator.id}`}>
                        <ListItemIcon>
                           <FontAwesomeIcon size={'2x'} icon={['fas', "folder"]} color={colors[i]} transform="shrink-3" />
                        </ListItemIcon>
                        <ListItemText primary={incubator.name} />
                     </ListItem>
                  )}
               </>
            )}
         </List>
      </div>
   );
}
const IncubatorListItemsStateToProps = (state) => {
   let curDate = new Date();
   return {
      isLoaded: state.PortfolioReducer.isLoaded,
      incubators: state.PortfolioReducer.portfolioList.sponsored.filter(x =>{
         let incubatorIsActive = moment(curDate).isSameOrBefore(x.incubatorEndTime ? x.incubatorEndTime: x.proposalDueTime, 'day');
         return(x.privacyType === SharedConstants.PortfolioType.Sponsored && incubatorIsActive)
      }
      ).sort(
         (a, b) => b.id - a.id
      )
   }
};

const IncubatorList = connect(
   IncubatorListItemsStateToProps,
   () => { }
)(IncubatorListBase);


export default class LandingV2 extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         searchReturns: undefined,
      }
   }

   componentDidMount() {
      try {
         //loads the calendar if it failed to the first time
         _tkf.loadDeclaredCalendars()
      }
      catch(e){
         console.warn('could not load tockify');
      }
   }

   render(){
      return (
         <div id={'homePageContainer'} className={'page-container'} >
            <Grid container spacing={2}>
               <Grid style={{ 
                  alignSelf: 'start', 
                  margin: '16px 0 16px 0px',
                  paddingLeft: '24px' }} item sm={9} md={9} lg={9}>
                  <MPubSearchList
                     lastFilterFunction={this.props.lastFilterFunction}
                  />
                  <hr />
                  <ul
                     className="juicer-feed"
                     data-feed-id="polyplexors"
                     data-per="25"
                     data-columns="3"
                     data-pages="2"
                     data-overlay="true"
                  />
               </Grid>
               <Grid item sm={3} md={3} lg={3}>
                  <div className='right-column-fixed'>
                     <AskMeAnythingCard amaCards={this.props.amaCards}/>
                     <div className='announcements-wrapper'>
                     {this.props.headlines.slice(0,3).map((headline,i) => <AnnouncementsCard key={i} headline={headline}/>)}
                     </div>
                     <br />
                     <hr />
                     <div data-tockify-component="mini" data-tockify-calendar="polyplexus"></div>
                     <hr />
                     <IncubatorList />
                  </div>
               </Grid>
            </Grid>
         </div>
      );
   }
}
